import React, {FC, PropsWithChildren} from 'react';
import {ThemeProvider} from 'styled-components';

import {darkSidebarTheme} from '../../../../libs/shared/ui/src/theme/dark/darkTheme';
import {UserTheme} from '../../../../libs/shared/ui/src/theme/themeTypes';
import {UserThemesEnum} from '../../../../libs/shared/ui/src/theme/userThemesEnum';
import {useAppSelector} from '../../../helpers/appReduxHelpers';
import {getTheme} from '../../../store/data/preferences/preferencesSelectors';

export const DarkSidebarThemeProvider: FC<PropsWithChildren<unknown>> = ({children}) => {
  const theme = useAppSelector(getTheme);

  const mergeTheme = (inheritedTheme: UserTheme) =>
    theme === UserThemesEnum.DARK_SIDEBAR ? darkSidebarTheme : inheritedTheme;

  // Render the theme provider unconditionally to prevent our subtree from re-mounting.
  return <ThemeProvider theme={mergeTheme}>{children}</ThemeProvider>;
};
